// CreateDemonstrationStep shares CreateRecordingStep's recorder argument
// shape (same recorder pipeline; demonstration mode is selected at the Step
// subclass level via `getRecordingMode`), plus an optional `referenceRef`:
// the space object / position-list entry / Locate output the demonstration
// is anchored to. When set, the step resolves its world pose (at
// `referenceIndex`, default 0) at record start and stores it on the recording
// as the reference frame.
import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';

import CreateRecordingArguments from '../CreateRecording/Arguments';

export type { TagExpression, TagValue } from '../CreateRecording/Arguments';

export default CreateRecordingArguments.extend({
  referenceRef: zod.string().optional(),
  // Entry of a multi-entry reference position list to anchor to. Absent ⇒
  // first entry. Ignored for single-pose references / Locate outputs.
  referenceIndex: zod.number().int().nonnegative().optional(),
  // Direct world-frame reference pose, already resolved by the dispatcher
  // (e.g. the wizard's live Locate result at record start). Takes precedence
  // over `referenceRef` — no Space lookup happens when this is set.
  referenceWorldPose: CartesianPose.optional(),
});
